/* global jQuery */
import jQuery from 'jquery';
import Svg4Everybody from 'svg4everybody';

import debounce from './modules/utils/debounce';
import heightMatch from './modules/utils/height-match';
import Filters from './modules/filters';
import GAEventTracking from './modules/ga-event-tracking';
import GoogleMap from './modules/google-map';
import Header from './modules/header';
import Slider from './modules/slider';
import SocialSharing from './modules/social-sharing';
import Standfirst from './modules/standfirst';
import Tiles from './modules/tiles';

(function ($) {
    /**
     * Filters
     */
    new Filters('.js-filters');

    /**
     * Google Analytics Event Tracking
     */
    new GAEventTracking();

    /**
     * Google Analytics Event Tracking
     */
    new GoogleMap('.js-custom-google-map');

    /**
     * Header
     */
    new Header();

    /**
     * Slider
     */
    new Slider('.js-slider');

    /**
     * Social sharing
     */
    new SocialSharing('.js-social-share');

    /**
     * Standfirst
     */
    new Standfirst();

    /**
     * SVG4Everybody
     */
    new Svg4Everybody();

    /**
     * Tiles
     */
    new Tiles($('.js-tile'));

    /**
     * Footer
     */
    const $footer        = $('.js-footer-container');
    const $footerColumns = $('.js-footer-column');

    $(window).on('load resize', debounce((e) => {
        if (e.type === 'resize') {
            $footerColumns.css('height', 'auto');
        }

        heightMatch($footer, $footerColumns);
    }, 300));
}(jQuery));

